export const CommonEnum = {
    cookieName : 'auth_token',
    Bearer : 'Bearer',
    redirectQuery : '?redirect=',
    headerAuthorization : 'Authorization',
    spaceChar : ' ',
    equalChar : "=",
    dotCommaChar : ';',
    headerContentType : 'Content-Type',
    appJsonType  : 'application/json',
    validService : 'valid',
    expiresCookie : "expires=",
    pathCookie : ";path=/",
    domainCookie: ";domain=",
    hoursByDay : 24,
    minutesByHour : 60,
    secondsByMinute : 60,
    milisecondBySecond : 1000
}


// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/guard/common-enum.ts